let document_ready = false;

const bundle_sizes = document.querySelectorAll('.js-bundle-size');
const bundle_variant_inputs = document.querySelectorAll('.bundle-product');
const bundle_containers = document.querySelectorAll('.js-bundle__container');

const bundle_data_elem = document.querySelector('#bundle-data');
const data = bundle_data_elem ? JSON.parse(bundle_data_elem.innerHTML) : null;

let current_size = bundle_sizes.length > 0 ? [...bundle_sizes].find(x => x.checked).value : null;

if (!data) throw new Error('No Dataset - Bundle won\'t work');

const updateCurrentSize = (value) => {
  current_size = value;
  document.querySelectorAll('.js-bundle-current-size').forEach(elem => {
    elem.innerHTML = current_size;
  });
};

const updateAllSubtitles = () => {
  data.bundleProducts.forEach((bundle_product, index) => {
    const quantity = bundle_product.sizes.find(x => x.size == current_size).value;
    const container = document.getElementById(`bundle-container-${index}`);
    const subTitleElem = container?.querySelector('.js-bundle-variant-subtitle');

    if (subTitleElem) {
      subTitleElem.innerHTML = `${quantity} ${theme.strings?.pcs ?? 'pcs'}`;
    }
  });
};

const getFormData = () => {
  const bundleId = Date.now();
  const bundleTitle = document.querySelector('.product-single__title').textContent;
  const selectedProducts = [];

  // Gather selected bundle products
  data.bundleProducts.forEach((bundle_product, i) => {
    const input = document.querySelector(`.bundle-product[name="bundle-${i}"]:checked`);
    if (!input) return;

    const id = String(input.value);
    const quantity = bundle_product.sizes.find(x => x.size == current_size).value;
    const title = input.getAttribute('title') || input.dataset.title || bundle_product.title || "Unnamed Product";

    // Assign Gift Bag based on index
    let bag = "";
    if (i === 0) bag = "Gift Bag 1";
    else if (i === 1) bag = "Gift Bag 2";
    else if (i === 2) bag = "Gift Bag 3";
    else if ([3, 4, 5].includes(i)) bag = "Gift Bag 4";

    const item = {
      id,
      quantity: Number(quantity),
      title,
      properties: {
        Kit: `${bundleTitle} - ${current_size}`,
        _size: current_size,
        _productTitle: title,
        _bundleId: String(bundleId),
        _project: bag // ✅ assign bag name here
      }
    };

    // Include metafields if any
    const variant = bundle_product.variants.find(v => String(v.id) === id);
    if (variant?.metafields?.contents) {
      item.properties[window.theme.strings.kitContent ?? 'Hverdagskit'] = variant.metafields.contents;
    }

    selectedProducts.push(item);
  });

  // Group items by Gift Bag
  const groupedByBag = {};
  selectedProducts.forEach(item => {
    const bag = item.properties._project;
    if (!groupedByBag[bag]) groupedByBag[bag] = [];
    groupedByBag[bag].push(item);
  });

  // Build _bundleProducts summary
  const bundleProductsSummary = Object.entries(groupedByBag).map(([bag, items]) => {
    const details = items.map(i => `${i.title} x ${i.quantity}`).join("\n ");
    return `${bag}: ${details}`;
  });

  // Create master product
  let masterItem = null;
  if (data.masterProduct) {
    masterItem = {
      id: String(data.masterProduct.variants[0].id),
      quantity: 1,
      properties: {
        Kit: `${bundleTitle} - ${current_size}`,
        _size: current_size,
        _bundleId: String(bundleId),
        _bundlePatternUrl: `/products/${data.masterProduct.handle}`,
        _bundleUrl: String(window.location.href),
        _bundleProducts: bundleProductsSummary.join("\n"),
        _bundleMaster: "true"
      }
    };
  }

  // Final items array (master last)
  const items = masterItem ? [...selectedProducts, masterItem] : [...selectedProducts];

  console.log("Bundle Form Data:", { items });
  return { items };
};

const updateHtmlPrice = () => {
  let total_price = data.masterProduct ? data.masterProduct.price : 0;
  let total_compare_at_price = data.masterProduct ? data.masterProduct.compare_at_price || data.masterProduct.price : 0;

  data.bundleProducts.forEach((bundle_product, index) => {
    const input = document.querySelector(`.bundle-product[name^="bundle-${index}"]:checked`);
    if (input) {
      const quantity = bundle_product.sizes.find(x => x.size == current_size).value;

      const price = parseFloat(input.dataset.price) || 0;
      const comparePrice = parseFloat(input.dataset.compareAtPrice) || price;

      total_price += price * quantity;
      total_compare_at_price += comparePrice * quantity;
    }
  });

  const bundle_price_elem = document.querySelectorAll('[data-bundle-price]');
  const bundle_compare_at_price_elem = document.querySelector('[data-price-wrapper]');

  bundle_price_elem.forEach(elem => {
    elem.innerHTML = theme.Currency.formatMoney(total_price, theme.settings.moneyFormat);
  });

  if (total_compare_at_price > total_price) {
    bundle_compare_at_price_elem.classList.remove('hide');
    const compare_at_price_html = `
      <span class="product__price product__price--compare vb">
        ${theme.Currency.formatMoney(total_compare_at_price, theme.settings.moneyFormat)}
      </span>`;
    bundle_compare_at_price_elem.innerHTML = compare_at_price_html;
  } else {
    bundle_compare_at_price_elem.classList.add('hide');
  }

  if (document_ready) {
    window.bundle = getFormData();
  }
};

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!input.classList.contains('bundle-product')) return;

  const bundleLoop = input.name.split('-')[1];
  const container = document.getElementById(`bundle-container-${bundleLoop}`);
  const titleElem = container?.querySelector('.js-bundle-variant-title');
  const titlez = input.getAttribute('title') || input.dataset.title || '';
  const lastPart = titlez.split('-').pop().trim();
  const subTitleElem = container?.querySelector('.js-bundle-variant-subtitle');
  const imgElem = container?.querySelector('img');
  console.log('Clicked swatch input');

  const current_size = input.dataset.size; // ✅ You must set this via `data-size=""` on each input
  const quantity = data.bundleProducts[bundleLoop]?.sizes?.find(x => x.size == current_size)?.value ?? 1;

  if (titleElem) titleElem.innerHTML = lastPart;
  if (subTitleElem) subTitleElem.innerHTML = `${quantity} ${theme.strings?.pcs ?? 'pcs'}`;
  if (imgElem) imgElem.src = input.closest('.js-bundle__variant').querySelector('img').src;

  const drawer = document.getElementById(`BundleDrawer-${bundleLoop}`);
  if (drawer?.classList.contains("bundle-drawer--is-open")) {
    drawer.classList.remove("bundle-drawer--is-open");
    document.querySelector("html").classList.remove("js-drawer-open");
    document.querySelector(".bundle-drawer-overlay").style.display = "none";
  }

  updateHtmlPrice();
});


bundle_sizes.forEach(input => {
  input.addEventListener('change', () => {
    updateCurrentSize(input.value);
    updateHtmlPrice();
    updateAllSubtitles();
  });
});

window.addEventListener('load', () => {
  document.querySelector('.bundle__section')?.classList.remove('loading');
  document_ready = true;

  updateCurrentSize([...bundle_sizes].find(x => x.checked).value);

  data.bundleProducts.forEach((bundle_product, index) => {
    const firstVariant = document.querySelector(`.bundle-product[name="bundle-${index}"]`);
    const checkedVariant = document.querySelector(`.bundle-product[name="bundle-${index}"]:checked`);

    // Select the first variant by default if none is selected
    if (!checkedVariant && firstVariant) {
      firstVariant.checked = true;
    }

    const currentInput = document.querySelector(`.bundle-product[name="bundle-${index}"]:checked`);
    if (currentInput) {
      const container = document.getElementById(`bundle-container-${index}`);
      const titleElem = container?.querySelector('.js-bundle-variant-title');
      const titlez = currentInput.getAttribute('title') || currentInput.dataset.title || '';
      const lastPart = titlez.split('-').pop().trim();
      const subTitleElem = container?.querySelector('.js-bundle-variant-subtitle');
      const imgElem = container?.querySelector('img');

      const quantity = bundle_product.sizes.find(x => x.size == current_size).value;

      if (titleElem) titleElem.innerHTML = lastPart;
      if (subTitleElem) subTitleElem.innerHTML = `${quantity} ${theme.strings?.pcs ?? 'pcs'}`;
      if (imgElem) imgElem.src = currentInput.closest('.js-bundle__variant').querySelector('img').src;
    }
  });

  updateHtmlPrice();
  updateCartItemsWindowArr(() => (window.bundle = getFormData()));
  window.bundle = getFormData();
});